<template>
    <div class="mobile-menu">
        <ul class="mobile-menu__actions">
            <li class="mobile-menu__action">
                <a href="#" class="action-link" @click.prevent="">
                    <span class="material-icon icon-keyboard_arrow_left"/>
                    <span class="action-link__txt">{{ $t('back') }}</span>
                </a>
            </li>
        </ul>
        <a href="#" @click.prevent="" class="mobile-menu__btn -green">
            <span class="material-icon icon-check"/>
        </a>
    </div>
</template>

<script>
  import MobileCropperMenu from 'src/mixins/mobileCropperMenuComponent';

  export default {
    mixins: [MobileCropperMenu],
  };
</script>
